import { render, staticRenderFns } from "./IconScale.vue?vue&type=template&id=729fd0c8&"
import script from "./IconScale.vue?vue&type=script&lang=ts&"
export * from "./IconScale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports